interface FocusCycleIconProps {
  className?: string
  style?: React.CSSProperties
}

export const FocusCycleIcon: React.FC<FocusCycleIconProps> = ({
  className = "text-white",
  style,
}) => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
  >
    <g id="Fokus">
      <g id="Ellipse 71" filter="url(#filter0_f_2260_22506)">
        <circle
          cx="21.999"
          cy="21.9502"
          r="16.4465"
          stroke="#FFF440"
          strokeWidth="1.10704"
        />
      </g>
      <circle
        id="Ellipse 72"
        cx="21.999"
        cy="21.9502"
        r="16.4465"
        stroke="#FFF440"
        strokeWidth="1.10704"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_2260_22506"
        x="0.570881"
        y="0.522053"
        width="42.8563"
        height="42.8563"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="2.21407"
          result="effect1_foregroundBlur_2260_22506"
        />
      </filter>
    </defs>
  </svg>
)
